exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: inline-block;\n  margin-left: 12px;\n  font-size: 14px;\n}\n\n.standard-pin-checkbox label {\n  margin: 0 6px 0 0;\n  cursor: pointer;\n}\n\n.standard-pin-checkbox small {\n  margin-right: 6px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standard-pin-checkbox.component.css
// module id = ../../../../../src/app/content-page/admin/standards-management/standard-pin-checkbox.component.css
// module chunks = main